module.exports = __webpack_public_path__ + "static/location-info7-0290b42a902a333540cbbb4cd5426358.jpg";